const cookieName = 'shipping_location';
const oneMonthInSeconds = 30 * 24 * 60 * 60;
const cookie = useCookie(cookieName, {
    maxAge: oneMonthInSeconds,
    sameSite: true,
});

const getLocation = async () => {
    if (cookie.value) {
        return cookie.value;
    }

    try {
        const response = await useAuth().apiRequest('POST', 'fetch-location');
        cookie.value = response;
    } catch (_error) {
        cookie.value = { country: 'none' };
    }

    return cookie.value;
};

const setLocation = (cookieData: any) => {
    cookie.value = cookieData;
};

const clearLocation = () => {
    cookie.value = JSON.stringify({ country: 'none' });
};

export default defineNuxtPlugin(() => {
    return {
        provide: {
            location: getLocation,
            setLocation: setLocation,
            clearLocation: clearLocation,
        },
    };
});
